import { useRef, useState } from "react";
import { api } from "../../lib/api";

export const useGuardVoice = (levelRef) => {
  const [listening, setListening] = useState(false);
  const [speaking, setSpeaking] = useState(false);
  const rec = useRef(null), actx = useRef(null), audio = useRef(null);
  const ctx = async () => { actx.current = actx.current || new (window.AudioContext || window.webkitAudioContext)(); await actx.current.resume(); return actx.current; };
  const meter = (an, stop) => {
    const buf = new Uint8Array(an.fftSize);
    const loop = () => {
      if (stop()) { levelRef.current = 0; return; }
      an.getByteTimeDomainData(buf);
      let sum = 0;
      for (const v of buf) sum += ((v - 128) / 128) ** 2;
      levelRef.current = Math.sqrt(sum / buf.length);
      requestAnimationFrame(loop);
    };
    loop();
  };

  const start = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    const mime = MediaRecorder.isTypeSupported("audio/webm") ? "audio/webm" : "audio/mp4";
    const r = new MediaRecorder(stream, { mimeType: mime });
    const chunks = [];
    r.ondataavailable = (e) => e.data.size && chunks.push(e.data);
    r.start();
    rec.current = { r, stream, mime, chunks, on: true };
    try { const c = await ctx(); const an = c.createAnalyser(); an.fftSize = 512; c.createMediaStreamSource(stream).connect(an); meter(an, () => !rec.current?.on); } catch (_) { /* level meter optional */ }
    setListening(true);
  };

  const stop = () => new Promise((resolve) => {
    const cur = rec.current;
    if (!cur) return resolve("");
    cur.on = false;
    cur.r.onstop = async () => {
      cur.stream.getTracks().forEach((t) => t.stop());
      setListening(false);
      const fd = new FormData();
      fd.append("file", new Blob(cur.chunks, { type: cur.mime }), cur.mime.includes("mp4") ? "speech.mp4" : "speech.webm");
      try { resolve((await api.post("/mari/voice/transcribe", fd)).data.text || ""); } catch (_) { resolve(""); }
    };
    cur.r.stop();
  });

  const speak = async (text) => {
    try {
      const r = await api.post("/mari/voice/speak", { text, voice: "onyx" }, { responseType: "blob" });
      audio.current?.pause();
      const a = new Audio(URL.createObjectURL(r.data));
      audio.current = a;
      let done = false;
      try { const c = await ctx(); const an = c.createAnalyser(); an.fftSize = 512; c.createMediaElementSource(a).connect(an); an.connect(c.destination); meter(an, () => done); } catch (_) { /* plays without meter */ }
      setSpeaking(true);
      a.onended = () => { done = true; setSpeaking(false); };
      await a.play();
    } catch (_) { setSpeaking(false); }
  };
  const hush = () => { audio.current?.pause(); setSpeaking(false); levelRef.current = 0; };
  return { listening, speaking, start, stop, speak, hush };
};
